import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Results from './ValidationResults';
import {
  actions,
  selectors,
} from '../../store/dux/field-boundary-management-dux';

export function ValidateFields(props) {
  const { aaids, close } = props;
  const dispatch = useDispatch();
  const results = useSelector(selectors.validationResults);

  useEffect(() => {
    dispatch(actions.clearResults());
  }, [dispatch]);

  useEffect(() => {
    dispatch(actions.validateFields(aaids));
  }, [aaids, dispatch]);

  return <Results validationResults={results} handleClose={close} />;
}
